<template>
    <div>
        <div class="sche1">架构数列</div>
        <!-- 新 -->
        <div style="display:flex">
            <!-- <el-menu
            class=""
            style="width:320px;height: 800px;"
            background-color="#fff"
            text-color="#fff"
            :unique-opened="true"
            active-text-color="#fff">
            <el-submenu v-for="(item,index) in companyList" :key="'one'+index" :index="'one'+index">
              <template slot="title">
                <div class="titles">
                    <span @click="qiehuan1(item)" class="spans"><img class="imgs" src="@/assets/imgs/14.png" alt="">{{item.name.substring(0,5)}}</span>
                </div>
              </template>
              <el-submenu style="width:100%" v-for="(item1,index1) in departmentList" :key="'two'+index1" :index="'two'+index1">
                <template slot="title">
                    <div class="titles">
                        <span class="spans" @click="qiehuan(item1)"><img class="imgs" src="@/assets/imgs/21.png" alt="">{{item1.name.substring(0,5)}}</span>
                    </div>
                </template>
                <el-submenu v-for="(item2,index2) in departmentList1" :key="'three'+index2" :index="'three'+index2">
                    <template slot="title">
                        <div class="titles">
                            <span @click="qiehuan2(item2)" class="spans"><img class="imgs" src="@/assets/imgs/21.png" alt="">{{item2.name.substring(0,5)}}</span>
                        </div>
                    </template>
                    <el-submenu v-for="(item3,index3) in departmentList2" :key="'four'+index3" :index="'four'+index3">
                        <template slot="title">
                            <div class="titles">
                                <span @click="qiehuan3(item3)" class="spans"><img class="imgs" src="@/assets/imgs/21.png" alt="">{{item3.name.substring(0,5)}}</span>
                            </div>
                        </template>
                    </el-submenu>
                </el-submenu>
              </el-submenu>
            </el-submenu>
          </el-menu> -->
          <div class="lili">
            <el-tree
            :data="data1" 
            :accordion="true"
            :indent="10"
            :props="defaultProps"
            @node-click="handleNodeClick">
            </el-tree>
          </div>

          <div class="news1">
            <div class="news2">
                <div class="news2-1">{{companyName}}</div>
                <div class="news2-2" @click="bianji">
                    <img class="img1" src="@/assets/imgs/22.png" alt="">
                    <p>编辑</p>
                </div>
                <div class="news2-3" @click="addChild">
                    <img class="img2" src="@/assets/imgs/24.png" alt="">
                    <p>添加子部门</p>
                </div>
                <div class="news2-4" @click="deletes" v-if="flags != 0">
                    <img class="img3" src="@/assets/imgs/23.png" alt="">
                    <p>删除</p>
                </div>
            </div>
            <!-- <div class="news3" v-if="zhanshi1 == 1">
                <div>{{originName1}}</div>
                <div></div>
            </div>
            <div class="news3" v-else-if="zhanshi1 == 2">
                <div>{{originName1}}/</div>
                <div>{{originName2}}</div>
            </div>
            <div class="news3" v-else>
                <div>{{originName1}}/</div>
                <div>{{originName2}}/</div>
                <div>{{originName3}}</div>
            </div> -->
            <div class="news4">
                <div class="news4-1">
                    <img class="news4-1-1" src="@/assets/imgs/14.png" alt="">
                    <div class="news4-1-2">下级部门</div>
                </div>
                <div v-if="nextList.length != 0">
                    <div class="news4-2" v-for="(item,index) in nextList" :key="'one'+index" :index="'one'+index">
                        <div @click="bms(item)" class="news4-2-1">
                            <div>{{item.name}}</div>
                            <div>></div>
                        </div>
                    </div>
                </div>
                <div class="news4-2" v-if="nextList.length == 0">
                    <div class="news4-2-2">
                        <div>当前部门没有子部门</div>
                    </div>
                </div>
            </div>
            <div style="height:350px;background-color: #ffffff;">
                <div class="news5">
                    <div class="news4-1">
                        <img class="news4-1-1" src="@/assets/imgs/25.png" alt="">
                        <div class="news4-1-2">部门人员</div>
                        <div class="news4-1-2">({{chengyuan1}})</div>
                    </div>
                    <div class="news5-1">
                        <div class="news5-1-1" @click="addHuman">
                            <img class="imgdd" src="@/assets/imgs/26.png" alt="">
                            <div>添加成员</div>
                        </div>
                        <div class="news5-1-2" @click="exports1">
                            <img class="imgdd" src="@/assets/imgs/08.png" alt="">
                            <div>导出表格</div>
                        </div>
                    </div>
                    <div class="news6">
                        <Table border ref="selection" :columns="columns9" :data="dataList" :loading="loading">
                            <template slot-scope="{ row,index }" slot="action">
                                <div v-if="row.num == 1" class="news6-1" title="至少保留一个部门">
                                    <img class="news6-1-1" src="../../assets/imgs/43.png" alt="">
                                    <div style="color:#BBBBBB">退出</div>
                                </div>
                                <div v-else class="news6-1" @click="exit(row,index)" title="退出">
                                    <img class="news6-1-1" src="../../assets/imgs/42.png" alt="">
                                    <div style="color:#2176FA">退出</div>
                                </div>
                            </template>
                        </Table>
                    </div>
                </div>
                <div class="news7">
                    <Page :total="total4" :page-size="4" @on-change="nextPage4"/>
                </div>
            </div>
            <!-- <div class="news7">
                <Page :total="total4" :page-size="4" @on-change="nextPage4"/>
            </div> -->
          </div>
        </div>
         <!-- 设置领取限制 -->
         <xc-model :loading="setLimit" title="设置部门" :is_buttom="false" @cancel="qx">
            <div slot="mbody">
                <div class="sche21">
                    <div class="sche22">
                        <div class="sche23">部门名称：</div>
                        <input v-model="bumens" type="text" placeholder="请输入部门名称" class="sche24">
                    </div>
                    <!-- <div class="sche22">
                        <div class="sche23">产品领取数量：</div>
                        <input v-model="numbers" type="number" placeholder="默认每个产品领取（1）" class="sche24">
                    </div> -->
                    <div class="sche22">
                        <div class="sche23">部门编号：</div>
                        <input v-model="orgsCode" type="text" placeholder="请输入部门编号" class="sche24">
                    </div>
                    <div class="sche25">
                        <el-button style="line-height: 0" class="sche26" :loading="aduLoading" @click="knows">确认</el-button>
                        <div class="sche26" style="margin-left: 50px" @click="qx">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
        <!-- 设置领取限制1 -->
        <xc-model :loading="setLimit1" title="设置领取限制" :is_buttom="false" @cancel="qx1">
            <div slot="mbody">
                <div class="sche21">
                    <div class="sche22" style="margin-left:35px">
                        <div class="sche23">部门：</div>
                        <input v-model="bumens1" disabled type="text" placeholder="请输入部门" class="sche24">
                    </div>
                    <div class="sche22">
                        <div class="sche23">产品领取数量：</div>
                        <input v-model="numbers1" type="number" placeholder="默认每个产品领取（1）" class="sche24">
                    </div>
                    <div class="sche25">
                        <el-button style="line-height: 0" class="sche26" :loading="aduLoading" @click="knows1">确认</el-button>
                        <div class="sche26" style="margin-left: 50px" @click="qx1">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
        <!-- 添加部门弹框 -->
        <xc-model :loading="addApartment" title="添加部门" :is_buttom="false" @cancel="cancels">
            <div slot="mbody">
                <div class="sche21">
                    <div class="sche22">
                        <div class="sche23">部门名称：</div>
                        <input v-model="aparts" type="text" placeholder="请输入部门" class="sche24">
                    </div>
                    <div class="sche22">
                        <div class="sche23">上级部门：</div>
                        <input v-model="surperDepart" disabled type="text" placeholder="请输入上级部门" class="sche24">
                    </div>
                    <div class="sche22">
                        <div class="sche23">部门编号：</div>
                        <input v-model="bumenNum" type="text" placeholder="请输入部门编号" class="sche24">
                    </div>
                    <div class="sche25">
                        <el-button style="line-height: 0" class="sche26" :loading="aduLoading" @click="sures">确认</el-button>
                        <div class="sche26" style="margin-left: 50px" @click="cancels">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
        <!-- 添加部门弹框 -->
        <xc-model :loading="addApartment1" title="添加部门" :is_buttom="false" @cancel="cancels1">
            <div slot="mbody">
                <div class="sche21">
                    <div class="sche22">
                        <div class="sche23">部门名称：</div>
                        <input v-model="aparts1" type="text" placeholder="请输入部门" class="sche24">
                    </div>
                    <div class="sche25">
                        <el-button style="line-height: 0" class="sche26" :loading="aduLoading" @click="sures1">确认</el-button>
                        <div class="sche26" style="margin-left: 50px" @click="cancels1">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
        <!-- 修改部门弹框 -->
        <xc-model :loading="editApartment" title="修改部门" :is_buttom="false" @cancel="guanbi">
            <div slot="mbody">
                <div class="sche21">
                    <div class="sche22">
                        <div class="sche23">部门名称：</div>
                        <input v-model="ments" type="text" placeholder="请输入添加部门" class="sche24">
                    </div>
                    <div class="sche25">
                        <el-button style="line-height: 0" class="sche26" :loading="aduLoading" @click="queding">确认</el-button>
                        <div class="sche26" style="margin-left: 50px" @click="guanbi">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
        <!-- 修改部门弹框1 -->
        <xc-model :loading="editApartment1" title="修改部门" :is_buttom="false" @cancel="guanbi1">
            <div slot="mbody">
                <div class="sche21">
                    <div class="sche22">
                        <div class="sche23">部门名称：</div>
                        <input v-model="ments1" type="text" placeholder="请输入添加部门" class="sche24">
                    </div>
                    <div class="sche25">
                        <el-button style="line-height: 0" class="sche26" :loading="aduLoading" @click="queding1">确认</el-button>
                        <div class="sche26" style="margin-left: 50px" @click="guanbi1">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
        <!-- 删除部门弹框 -->
        <xc-model :loading="deleApartment" title="删除提示" :is_buttom="false" @cancel="closes">
            <div slot="mbody">
                <div class="sche21">
                    <div class="sche22">
                        <div class="sche23">此操作将永久删除该部门信息，是否删除？</div>
                        <!-- <input v-model="ments" type="text" placeholder="请输入添加部门" class="sche24"> -->
                    </div>
                    <div class="sche25">
                        <el-button style="line-height: 0" class="sche26" :loading="aduLoading" @click="opens">确认</el-button>
                        <div class="sche26" style="margin-left: 50px" @click="closes">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
        <!-- 删除部门弹框1 -->
        <xc-model :loading="deleApartment1" title="删除提示" :is_buttom="false" @cancel="closes1">
            <div slot="mbody">
                <div class="sche21">
                    <div class="sche22">
                        <div class="sche23">此操作将永久删除该部门信息，是否删除？</div>
                        <!-- <input v-model="ments" type="text" placeholder="请输入添加部门" class="sche24"> -->
                    </div>
                    <div class="sche25">
                        <el-button style="line-height: 0" class="sche26" :loading="aduLoading" @click="opens1">确认</el-button>
                        <div class="sche26" style="margin-left: 50px" @click="closes1">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
        <!-- 分配成员到本部门 -->
        <xc-model :loading="fenPeiApartment" title="分配成员到本部门" :is_buttom="false" @cancel="quxiao">
            <div slot="mbody">
                <div class="sche21" style="height:610px">
                    <div class="sche12" style="margin: 0 auto;">
                        <input v-model="ygName" type="text" placeholder="输入员工编码、姓名" placeholder-class="sche13" class="sche14">
                        <img @click="sousuos" src="../../assets/imgs/07.png" class="sche15">
                    </div>
                    <div class="sche12" style="margin: 10px auto;height: 1px;width:600px;background-color: #ddd;"></div>
                    <!-- 弹框表格 -->
                    <div class="sche19">
                        <Table border ref="selection4" :columns="columns8" :data="datas" :loading="loading">
                            <template slot-scope="{ row }" slot="action">
                                <Button size="small" style="margin-right: 5px;border: none;color: #2176FA;" @click="xiangqing(row)">添加</Button> 
                            </template>
                        </Table>
                    </div>
                    <div class="sche20-1">
                        <Page :total="total3" :page-size="5" @on-change="nextPage3"/>
                    </div>
                    <div class="sche25-1">
                        <el-button style="line-height: 0" class="sche26" :loading="aduLoading" @click="confire">确认</el-button>
                        <div class="sche26" style="margin-left: 50px" @click="quxiao">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
    </div>
</template>
<script>
import https from '@/api/schemaSequence';
import until from '@/util/util'
export default{
    inject: ["reload"],
    data(){
        return{
            data1: [],
            defaultProps: {
            children: 'children',
            label: 'name'
            },
            orgsCode:'',
            Pids:'',
            surperDepart:'',
            fatherId:'',
            bumenNum:'',
            originName1:'',
            originName2:'',
            originName3:'',
            zhanshi1:1,
            chengyuan1:'',
            nextList:[],
            flags:'',
            companyName:'',
            total4:0,
            dataList:[],
            columns9:[
                {
                    title: '成员姓名',
                    width: 190,
                    height:30,
                    align: 'center',
                    key: 'name'
                },
                {
                    title: '成员编号',
                    width: 190,
                    height:30,
                    align: 'center',
                    key: 'code'
                },
                {
                    title: '部门名称',
                    width: 190,
                    height:30,
                    align: 'center',
                    key: 'orgname'
                },
                {
                    title: '部门编号',
                    width: 190,
                    height:30,
                    align: 'center',
                    key: 'orgcode'
                },
                // {
                //     title: '子部门名称',
                //     width: 170,
                //     height:30,
                //     align: 'center',
                //     key: 'orgname2'
                // },
                // {
                //     title: '子部门编号',
                //     width: 170,
                //     height:30,
                //     align: 'center',
                //     key: 'orgcode2'
                // },
                {
                    title: '操作',
                    width: 180,
                    height:30,
                    align: 'center',
                    key:'action',
                    slot: 'action'
                },
            ],
            aas:'',
            heis:0,
            changeId:1,
            total3:0,
            datas:[],
            bumens:'',
            bumens1:'',
            numbers:1,
            numbers1:1,
            ygName:'',
            identifier:1,
            companyId:'',
            allMentsName:'全组织',
            user:'',
            aparts:'',
            aparts1:'',
            ments:'',
            ments1:'',
            addApartment:false,
            addApartment1:false,
            editApartment:false,
            editApartment1:false,
            deleApartment:false,
            deleApartment1:false,
            fenPeiApartment:false,
            setLimit:false,
            setLimit1:false,
            aduLoading:false,
            activeNames:[],
            flag:true,
            selt:true,
            loading:false,
            total:0,
            total1:0,
            total2:0,
            totals:0,
            searchs:'',
            companyList:[],
            departmentList:[],
            staffList:[],
            isShow:'',
            choseId21:'',
            choseId2:'',
            choseId3:'',
            choseId31:'',
            ddds:'',
            data6:[],
            data7:[],
            data8:[],
            departmentList1:[],
            page:1,
            FirstId:'',
            companyFirstId:'',
            pageSize:4,
            columns8:[
                {
                    title: '员工编码',
                    width: 150,
                    height:30,
                    align: 'center',
                    key: 'code'
                },
                {
                    title: '姓名',
                    width: 150,
                    align: 'center',
                    key: 'name'
                },
                {
                    title: '部门',
                    width: 150,
                    align: 'center',
                    key: 'orgname'
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 150,
                    align: 'center'
                }
            ],
            columns7: [
            {
                title: '员工编码',
                key: 'code',
                align: 'center',
                width: 330,
                render: (h, params) => {
                return h('div', [
                    h('Icon', {
                    props: {
                        type: 'person'
                    }
                    }),
                    h('strong', params.row.code)
                ]);
                }
            },
            {
                title: '姓名',
                width: 330,
                align: 'center',
                key: 'name'
            },
            {
                title: '部门',
                width: 330,
                align: 'center',
                key: 'orgName'
            },
        ],
        page1:{
            orgId:'',
            userId:'',
            companyId:'',
            cuserId:'' 
        }
        }
    },
    mounted(){
        this.user = JSON.parse(sessionStorage.getItem('user'));
        this.companyId = this.user.companyId

        let datas = {
            companyid:this.user.companyId,
        }
        https.orgbycompany(datas).then(res=>{
            this.data1 = res.data
            this.FirstId = res.data[0].id
            this.fatherId = res.data[0].id
            this.Pids = res.data[0].pid
            this.companyName = res.data[0].name
            this.bumens = res.data[0].name
            this.companyFirstId = res.data[0].companyid
            this.orgsCode = res.data[0].orgcode
            this.choseId2 = res.data[0].id
            this.nextList = res.data[0].children
            let data2 = {
                orgId:this.FirstId,
                page:this.page,
                pageSize:this.pageSize
            };
            https.orgApiGetorgnetall(data2).then(res=>{
                this.dataList = res.data.user
                this.chengyuan1 = res.data.totalNum
                this.total4 = res.data.totalNum
            })
        })

        // let data = {
        //     companyId:this.user.companyId,
        //     pid:0
        // };
        // https.orgListSearch(data).then(res=>{
        //     this.companyList = res.data.orglist
        //     this.FirstId = this.companyList[0].id
        //     this.Pids = this.companyList[0].pid
        //     this.companyName = this.companyList[0].name
        //     this.originName1 = this.companyList[0].name
        //     this.surperDepart = this.companyList[0].name
        //     this.numbers = this.companyList[0].goodsnum
        //     this.orgsCode = this.companyList[0].orgcode
        //     this.choseId2 = this.companyList[0].id
        //     this.bumens = this.companyList[0].name
        //     this.fatherId = this.companyList[0].id
        //     this.companyFirstId = this.companyList[0].companyId
        //     let datas = {
        //         companyId:this.companyFirstId,
        //         pid:this.FirstId
        //     };
        //     https.orgListSearch(datas).then(res=>{
        //         this.departmentList = res.data.orglist
        //         this.nextList = res.data.orglist
        //     })
        //     let data2 = {
        //         orgId:this.FirstId,
        //         page:this.page,
        //         pageSize:this.pageSize
        //     };
        //     https.orgApiGetorgnetall(data2).then(res=>{
        //         this.dataList = res.data.user
        //         this.chengyuan1 = res.data.totalNum
        //         this.total4 = res.data.totalNum
        //     })
        // })
        // 根据公司id查询下面所有人员
        let data1 = {
            page:this.page,
            pageSize:this.pageSize,
            companyid:this.user.companyId
        }
        https.orgApiGetorg(data1).then(res=>{
            // this.data6 = res.data.dataList
            this.data7 = res.data.dataList
            this.total = res.data.totalNum
            this.totals = res.data.totalNum
        })
        // 搜索成员
        let data2 = {
            companyId:this.companyId,
            keyword:this.ygName,
            page:this.page,
            pageSize:5
        }
        https.orgApiOrguser(data2).then(res=>{
            this.datas = res.data.userlist
            this.total3 = res.data.totalNum
            this.loading = false
        })
    },
    methods:{
        // 成员退出部门
        exit(row,index){
            this.page1.orgId = row.orgId
            this.page1.userId = row.userid
            this.page1.companyId = this.companyId
            this.page1.cuserId = this.user.userId
            https.putoutorg(this.page1).then(res=>{
               switch(res.code) {
                case '0000':
                    this.$message.success('退出成功')
                    setTimeout(() => {
                        this.reload();
                    }, 500);
                    break;
                case '1002':
                    this.$message.error('用户不在该公司')
                    break;
                case '1003':
                    this.$message.error('必须保留一个组织架构')
                    break;
               }
            })
        },
        handleNodeClick(item) {
            this.flags = item.pid
            this.FirstId = item.id
            this.page1.orgId = item.id
            this.orgsCode = item.orgcode
            this.surperDepart = item.name
            this.companyFirstId = item.companyid
            this.Pids = item.pid
            this.choseId3 = item.id
            this.bumens = item.name
            this.numbers = item.goodsnum
            this.fatherId = item.id
            this.choseId2 = item.id
            this.originName3 = item.name
            this.companyName = item.name
            let data3 = {
                orgId:this.FirstId,
                page:this.page,
                pageSize:this.pageSize
            };
            https.orgApiGetorgnetall(data3).then(res=>{
                this.dataList = res.data.user
                this.total4 = res.data.totalNum
                this.chengyuan1 = res.data.totalNum
            })
            let datas = {
                companyId:this.companyFirstId,
                pid:this.FirstId
            };
            https.orgListSearch(datas).then(res=>{
                this.nextList = res.data.orglist
            })
        },
        bms(item){
            this.page1.orgId = item.id
            this.FirstId = item.id
            let data2 = {
                orgId:this.FirstId,
                page:this.page,
                pageSize:this.pageSize
            };
            https.orgApiGetorgnetall(data2).then(res=>{
                this.dataList = res.data.user
                this.total4 = res.data.totalNum
                this.chengyuan1 = res.data.totalNum
            })
        },
        // 添加成员
        addHuman(){
            this.fenPeiApartment = true
        },
        // 编辑
        bianji(){
            this.setLimit = true
        },
        // 添加子部门
        addChild(){
            this.addApartment = true
        },
        // 删除
        deletes(){
            this.deleApartment = true
        },
        nextPage4(e){
            let data2 = {
                orgId:this.FirstId,
                page:e,
                pageSize:this.pageSize
            };
            https.orgApiGetorgnetall(data2).then(res=>{
                this.dataList = res.data.user
                this.total4 = res.data.totalNum
            })
        },
        exports1(){
            this.$Loading.start();
            let data = {
                companyid:this.user.companyId,
                pid:this.choseId2
            }
            https.exportscxrypz(data).then(res=>{
                const blob = new Blob([res],{ type: 'application/vnd.ms-excel'});//处理文档流
                const fileName = '生产线人员配置表.csv';
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
                this.loading = false;
                this.$Loading.finish();
            })
        },
        tianjias(){
            this.addApartment1 = true
        },
        xiangqing(row){
            console.log(row,'lihang')
            let data = {
                mobile:row.mobile,
                mymobile:this.user.mobile,
                orgId:this.choseId2,
                sign:this.user.sign,
                companyId:this.user.companyId,
                cuserId:this.user.userId
            };
            https.putinorg(data).then(res=>{
                this.$message.success('添加成功')
                this.fenPeiApartment = false
                setTimeout(() => {
                    this.reload();
                }, 500);
            })
        },
        sousuos(){
            let data2 = {
                companyId:this.companyId,
                keyword:this.ygName,
                page:this.page,
                pageSize:7
            }
            https.orgApiOrguser(data2).then(res=>{
                this.datas = res.data.userlist
                this.total3 = res.data.totalNum
                this.loading = false
            })
        },
        // 设置领取限制
        setLiqu(ite){
            this.companyId = ite.companyId
            this.bumens = ite.name
            this.choseId2 = ite.id
            this.numbers = ite.goodsnum
            this.setLimit = true
        },
        // setLiqu1(ite){
        //     this.bumens1 = ite.name
        //     this.choseId21 = ite.id
        //     this.numbers1 = ite.goodsnum
        //     this.setLimit1 = true
        // },
        knows1(){
            this.aduLoading = true;
            let data = {
                id:this.choseId21,
                goodsnum:this.numbers1
            }
            if(this.numbers1<=0) {
                this.$message.error('数量不能少于一')
                this.aduLoading = false;
                return false;
            }
            https.updateorgbygoodsnum(data).then(res=>{
                if(res.code = '0000') {
                    this.$message.success('修改成功')
                    let data = {
                        companyId:this.user.companyId,
                        pid:0
                    };
                    https.orgListSearch(data).then(res=>{
                        this.companyList = res.data.orglist
                        this.FirstId = this.companyList[0].id
                        this.companyFirstId = this.companyList[0].companyId
                        let datas = {
                            companyId:this.companyFirstId,
                            pid:this.FirstId
                        };
                        https.orgListSearch(datas).then(res=>{
                            this.departmentList = res.data.orglist
                        })
                    })
                    this.setLimit1 = false
                    this.aduLoading = false;
                }
            })
        },
        qx1(){
            this.setLimit1 = false 
        },
        knows(){
            this.aduLoading = true;
            let data1 = {
                id:this.FirstId,
                companyId:this.user.companyId,
                name:this.bumens,
                pid:this.Pids,
                cuserid:this.user.userId,
                orgcode:this.orgsCode
            }
            if(this.bumens.lengh > 12) {
                this.$message.error('架构名称不能超过十二个字段')
                this.aduLoading = false;
                return false;
            }
            https.orgApiAddorupda(data1).then(res=>{
                if(res.code == '0000') {
                    this.$message.success('修改成功')
                    setTimeout(() => {
                        this.reload();
                    }, 500);
                    this.setLimit = false
                    this.aduLoading = false;
                }else if(res.code == '1002'){
                    this.$message.error('该部门编码已存在');
                    this.aduLoading = false;
                }
            })
        },
        qx(){
            this.setLimit = false
        },
        edits(params){
            console.log(params,'params')
        },
        cons(){
            console.log('真好')
        },
        qiehuan1(item){
            this.flags = ''
            this.originName1 = item.name
            this.surperDepart = item.name
            this.orgsCode = item.orgcode
            this.Pids = item.pid
            this.numbers = item.goodsnum
            this.bumens = item.name
            this.fatherId = item.id
            this.choseId2 = item.id
            this.zhanshi1 = 1
            this.FirstId = item.id
            this.companyName = item.name
            let data2 = {
                orgId:this.FirstId,
                page:this.page,
                pageSize:this.pageSize
            };
            https.orgApiGetorgnetall(data2).then(res=>{
                this.dataList = res.data.user
                this.total4 = res.data.totalNum
                this.chengyuan1 = res.data.totalNum
            })
            let datas = {
                companyId:this.companyFirstId,
                pid:this.FirstId
            };
            https.orgListSearch(datas).then(res=>{
                this.departmentList = res.data.orglist
                this.nextList = res.data.orglist
            })
        },
        qiehuan2(item){
            this.flags = 1
            this.FirstId = item.id
            this.orgsCode = item.orgcode
            this.surperDepart = item.name
            this.Pids = item.pid
            this.choseId3 = item.id
            this.bumens = item.name
            this.numbers = item.goodsnum
            this.fatherId = item.id
            this.choseId2 = item.id
            this.zhanshi1 = 3
            this.originName3 = item.name
            this.companyName = item.name
            let data3 = {
                orgId:this.FirstId,
                page:this.page,
                pageSize:this.pageSize
            };
            https.orgApiGetorgnetall(data3).then(res=>{
                this.dataList = res.data.user
                this.total4 = res.data.totalNum
                this.chengyuan1 = res.data.totalNum
            })
            let datas = {
                companyId:this.companyFirstId,
                pid:this.FirstId
            };
            https.orgListSearch(datas).then(res=>{
                this.departmentList2 = res.data.orglist
                this.nextList = res.data.orglist
            })
        },
        qiehuan3(item){
            this.flags = 1
            this.FirstId = item.id
            this.orgsCode = item.orgcode
            this.surperDepart = item.name
            this.Pids = item.pid
            this.choseId3 = item.id
            this.bumens = item.name
            this.numbers = item.goodsnum
            this.fatherId = item.id
            this.choseId2 = item.id
            this.zhanshi1 = 3
            this.originName3 = item.name
            this.companyName = item.name
            let data3 = {
                orgId:this.FirstId,
                page:this.page,
                pageSize:this.pageSize
            };
            https.orgApiGetorgnetall(data3).then(res=>{
                this.dataList = res.data.user
                this.total4 = res.data.totalNum
                this.chengyuan1 = res.data.totalNum
            })
            let datas = {
                companyId:this.companyFirstId,
                pid:this.FirstId
            };
            https.orgListSearch(datas).then(res=>{
                this.nextList = res.data.orglist
            })
        },
        qiehuan(item){
            this.flags = 1
            this.zhanshi1 = 2
            this.orgsCode = item.orgcode
            this.surperDepart = item.name
            this.companyName = item.name
            this.Pids = item.pid
            this.choseId3 = item.id
            this.fatherId = item.id
            this.numbers = item.goodsnum
            this.bumens = item.name
            this.originName2 = item.name
            this.changeId = item.companyId
            this.choseId2 = item.id
            this.FirstId = item.id
            this.identifier = this.choseId2
            this.allMentsName = item.name
            this.companyId = item.companyId
            let data1 = {
                companyId:item.companyId,
                pid:item.id
            };
            https.orgListSearch(data1).then(res=>{
                this.departmentList1 = res.data.orglist
                this.nextList = res.data.orglist
            })
            let data2 = {
                orgId:this.choseId2,
                page:this.page,
                pageSize:this.pageSize
            };
            https.orgApiGetorgnetall(data2).then(res=>{
                this.data8 = res.data.user
                this.total2 = res.data.totalNum
                this.totals = res.data.totalNum
            })
            let data3 = {
                orgId:this.FirstId,
                page:this.page,
                pageSize:this.pageSize
            };
            https.orgApiGetorgnetall(data3).then(res=>{
                this.dataList = res.data.user
                this.total4 = res.data.totalNum
                this.chengyuan1 = res.data.totalNum
            })
        },
        nextCheck(ite){
            // this.changeId = ite.id
            this.choseId2 = ite.id
            this.identifier = this.choseId2
            // this.allMentsName = ite.name
            this.companyId = ite.companyId
            // let data = {
            //     companyId:ite.companyId,
            //     pid:ite.id
            // }
            // https.orgListSearch(data).then(res=>{
            //     this.staffList = res.data.orglist
            // })
            let data1 = {
                orgId:this.choseId2,
                page:this.page,
                pageSize:this.pageSize
            };
            https.orgApiGetorgnetall(data1).then(res=>{
                this.data8 = res.data.user
                this.total2 = res.data.totalNum
                this.totals = res.data.totalNum
            })
        },
        // thidCheck(ites){
        //     this.choseId2 = ites.id
        //     this.identifier = this.choseId2
        //     this.allMentsName = ites.name
        //     this.companyId = ites.companyId
        //     let data1 = {
        //         orgId:this.choseId2,
        //         page:this.page,
        //         pageSize:this.pageSize
        //     };
        //     https.orgApiGetorgnetall(data1).then(res=>{
        //         this.data8 = res.data.user
        //         this.total2 = res.data.totalNum
        //         this.totals = res.data.totalNum
        //     })
        // },
        // 搜索
        seas(){
            this.loading = true
            this.identifier = 'sousuo'
            this.allMentsName = '全组织'
            let data = {
                companyId:this.changeId,
                keyword:this.searchs,
                page:this.page,
                pageSize:this.pageSize
            }
            https.orgApiOrguser(data).then(res=>{
                this.data7 = res.data.userlist
                this.total1 = res.data.totalNum
                this.totals = res.data.totalNum
                this.loading = false
            })
        },
        // seas1(){
        //     this.loading = true
        //     this.identifier = 'sousuo'
        //     let data = {
        //         companyId:this.companyId,
        //         keyword:this.searchs,
        //         page:this.page,
        //         pageSize:this.pageSize
        //     }
        //     https.orgApiOrguser(data).then(res=>{
        //         this.data7 = res.data.userlist
        //         this.total1 = res.data.totalNum
        //         this.loading = false
        //     })
        // },
        // 分页
        nextPage(e){
            this.loading = true;
            let data1 = {
                page:e,
                pageSize:this.pageSize,
                companyid:this.user.companyId
            }
            https.orgApiGetorg(data1).then(res=>{
                this.data6 = res.data.dataList
                this.total = res.data.totalNum
                this.loading = false;
            })
        },
        nextPage1(e){
            this.loading = true
            let data = {
                companyId:this.companyId,
                keyword:this.searchs,
                page:e,
                pageSize:this.pageSize
            }
            https.orgApiOrguser(data).then(res=>{
                this.data7 = res.data.userlist
                this.total1 = res.data.totalNum
                this.loading = false
            })
        },
        nextPage2(e){
            this.loading = true
            let data2 = {
                orgId:this.choseId2,
                page:e,
                pageSize:this.pageSize
            };
            https.orgApiGetorgnetall(data2).then(res=>{
                this.data8 = res.data.user
                this.total2 = res.data.totalNum
                this.loading = false
            })
        },
        nextPage3(e){
            let data2 = {
                companyId:this.companyId,
                keyword:this.ygName,
                page:e,
                pageSize:5
            }
            https.orgApiOrguser(data2).then(res=>{
                this.datas = res.data.userlist
                this.total3 = res.data.totalNum
                this.loading = false
            })
        },
        // 添加部门弹框
        addbumen(){
            this.addApartment = true
        },
        sures1(){
            if (this.aparts1 == '') {
                this.$message.error('请输入部门名称');
                return false;
            }
            if (until.isSpace(this.aparts1)) {
                this.$message.error('部门名称不能含有空格');
                return false;
            }
            if (this.aparts1.length < 3) {
                this.$message.error('架构名称最少为三位');
                return false;
            }
            if (until.checkNofh(this.aparts1)) {
                this.$message.error('架构名称不能含有符号');
                return false;
            }
            this.aduLoading = true;
            let data = {
                id:'',
                companyId:this.user.companyId,
                name:this.aparts1,
                pid:this.FirstId,
                cuserid:this.user.userId,
                orgcode:this.bumenNum
            }
            https.orgApiAddorupda(data).then(res=>{
                this.$message.success('已添加部门');
                this.aparts1 = ''
                this.addApartment1 = false
                this.aparts = ''
                let data = {
                    companyId:this.user.companyId,
                    pid:0
                };
                https.orgListSearch(data).then(res=>{
                    this.companyList = res.data.orglist
                    this.FirstId = this.companyList[0].id
                    this.companyFirstId = this.companyList[0].companyId
                    let datas = {
                        companyId:this.companyFirstId,
                        pid:this.FirstId
                    };
                    https.orgListSearch(datas).then(res=>{
                        this.departmentList = res.data.orglist
                    })
                })
                this.aduLoading = false;
            })
        },
        sures(){
            if (this.aparts == '') {
                this.$message.error('请输入架构名称');
                return false;
            }
            if (this.aparts.length > 12 ) {
                this.$message.error('架构名称不能超过十二个字段');
                return false;
            }
            if (until.isSpace(this.aparts)) {
                this.$message.error('架构名称不能含有空格');
                return false;
            }
            if (this.aparts.length < 3) {
                this.$message.error('架构名称最少为三位');
                return false;
            }
            if (until.checkNofh(this.aparts)) {
                this.$message.error('架构名称不能含有符号');
                return false;
            }
            if (this.bumenNum == '') {
                this.$message.error('请输入部门编号');
                return false;
            }
            this.aduLoading = true;
            let data = {
                id:'',
                companyId:this.user.companyId,
                name:this.aparts,
                pid:this.fatherId,
                cuserid:this.user.userId,
                orgcode:this.bumenNum
            }
            https.orgApiAddorupda(data).then(res=>{
                if(res.code == '0000'){
                    this.$message.success('已添加部门');
                    this.addApartment = false
                    this.aparts = ''
                    this.bumenNum = ''
                    setTimeout(() => {
                        this.reload();
                    }, 500);
                    this.aduLoading = false;
                }else if(res.code == '1002'){
                    this.$message.error('该部门编码已存在');
                    this.aparts = ''
                    this.bumenNum = ''
                    this.aduLoading = false;
                }
                
            })
        },
        cancels1(){
            this.addApartment1 = false
            this.aparts1 = ''
        },
        cancels(){
            this.addApartment = false
            this.aparts = ''
        },
        // 修改部门弹框
        editbm(ite,id){
            this.editApartment = true
            this.ments = ite.name
            this.ddds = ite.id
            this.choseId2 = id
        },
        editbm1(ite){
            this.editApartment1 = true
            this.ments1 = ite.name
            this.aas = ite.id
        },
        queding1(){
            if (this.ments1 == '') {
                this.$message.error('请输入部门名称');
                return false;
            }
            if (until.isSpace(this.ments1)) {
                this.$message.error('部门名称不能含有空格');
                return false;
            }
            if (this.ments1.length < 3) {
                this.$message.error('架构名称最少为三位');
                return false;
            }
            if (until.checkNofh(this.ments1)) {
                this.$message.error('架构名称不能含有符号');
                return false;
            }
            this.aduLoading = true;
            let data = {
                id:this.aas,
                companyId:this.user.companyId,
                name:this.ments1,
                pid:this.FirstId,
                cuserId:this.user.userId,
                orgcode:this.bumenNum
            }
            https.orgApiAddorupda(data).then(res=>{
                console.log(res)
                if(res.code == '1002') {
                    this.$message.error('该部门已存在')
                    this.aduLoading = false;
                }else if(res.code == '0000') {
                    this.$message.success('已修改该部门');
                    let data = {
                        companyId:this.user.companyId,
                        pid:0
                    };
                    https.orgListSearch(data).then(res=>{
                        this.companyList = res.data.orglist
                        this.FirstId = this.companyList[0].id
                        this.companyFirstId = this.companyList[0].companyId
                        let datas = {
                            companyId:this.companyFirstId,
                            pid:this.FirstId
                        };
                        https.orgListSearch(datas).then(res=>{
                            this.departmentList = res.data.orglist
                        })
                    })
                    this.aduLoading = false;
                    this.editApartment1 = false
                }
            })
        },
        guanbi1(){
            this.editApartment1 = false
        },
        queding(){
            if (this.ments == '') {
                this.$message.error('请输入部门名称');
                return false;
            }
            if (until.isSpace(this.ments)) {
                this.$message.error('部门名称不能含有空格');
                return false;
            }
            if (this.ments.length < 3) {
                this.$message.error('架构名称最少为三位');
                return false;
            }
            if (until.checkNofh(this.ments)) {
                this.$message.error('架构名称不能含有符号');
                return false;
            }
            this.aduLoading = true;
            let data = {
                id:this.ddds,
                companyId:this.user.companyId,
                name:this.ments,
                pid:this.choseId2,
                cuserId:this.user.userId,
                orgcode:this.bumenNum,
            }
            https.orgApiAddorupda(data).then(res=>{
                console.log(res)
                if(res.code == '1002') {
                    this.$message.error('该部门已存在')
                    this.aduLoading = false;
                }else if(res.code == '0000') {
                    this.$message.success('已修改该部门');
                    this.aduLoading = false;
                    this.editApartment = false
                }
            })
        },
        guanbi(){
            this.editApartment = false
        },
        // 删除部门弹框
        delebm(ite){
            this.choseId3 = ite.id
            this.deleApartment = true
        },
        delebm1(ite){
            this.choseId31 = ite.id
            this.deleApartment1 = true
        },
        closes(){
            this.deleApartment = false
        },
        closes1(){
            this.deleApartment1 = false
        },
        opens1(){
            this.aduLoading = true;
            let data = {
                id:this.choseId31,
                mobile:this.user.mobile,
                sign:this.user.sign,
            }
            https.orgApiDelorg(data).then(res=>{
                if(res.code == '0000') {
                    this.$message.success('已删除该部门')
                    let data = {
                        companyId:this.user.companyId,
                        pid:0
                    };
                    https.orgListSearch(data).then(res=>{
                        this.companyList = res.data.orglist
                        this.FirstId = this.companyList[0].id
                        this.companyFirstId = this.companyList[0].companyId
                        let datas = {
                            companyId:this.companyFirstId,
                            pid:this.FirstId
                        };
                        https.orgListSearch(datas).then(res=>{
                            this.departmentList = res.data.orglist
                        })
                    })
                    this.deleApartment1 = false
                    this.aduLoading = false;
                }else if(res.code == '1111') {
                    this.$message.error('删除失败')
                    this.aduLoading = false;
                }else if(res.code == '1002') {
                    this.$message.error('下面还存在自己帐号')
                    this.aduLoading = false;
                }
                console.log(res)
            })
        },
        opens(){
            this.aduLoading = true;
            let data = {
                id:this.choseId3,
                mobile:this.user.mobile,
                sign:this.user.sign,
            }
            https.orgApiDelorg(data).then(res=>{
                if(res.code == '0000') {
                    this.$message.success('已删除该部门')
                    this.deleApartment = false
                    setTimeout(() => {
                        this.reload();
                    }, 500);
                    this.aduLoading = false;
                }else if(res.code == '1111') {
                    this.$message.error('删除失败')
                    this.aduLoading = false;
                }else if(res.code == '1002') {
                    this.$message.error('下面还存在自己帐号')
                    this.aduLoading = false;
                }
                console.log(res)
            })
        },
        // 分配成员到本部门
        fenPeiry(ite){
            this.choseId2 = ite.id
            this.fenPeiApartment = true
        },
        quxiao(){
            this.ygName = ''
            let data2 = {
                companyId:this.companyId,
                keyword:this.ygName,
                page:this.page,
                pageSize:7
            }
            https.orgApiOrguser(data2).then(res=>{
                this.datas = res.data.userlist
                this.total3 = res.data.totalNum
                this.loading = false
            })
            this.fenPeiApartment = false
        },
        confire(){
            this.ygName = ''
            let data2 = {
                companyId:this.companyId,
                keyword:this.ygName,
                page:this.page,
                pageSize:7
            }
            https.orgApiOrguser(data2).then(res=>{
                this.datas = res.data.userlist
                this.total3 = res.data.totalNum
                this.loading = false
            })
            this.fenPeiApartment = false
        }
    }
}
</script>
<style scoped>
@import "schemaSequence.css";
</style>